// Angular-Module
import {Component, OnDestroy, OnInit} from '@angular/core';

@Component({
    selector: 'phscw-global-help-menu',
    templateUrl: './global-help-menu.component.html',
    styleUrls: ['./global-help-menu.component.scss'],
    standalone: false
})
export class GlobalHelpMenuComponent implements OnInit, OnDestroy {
    /**
     * Konstruktor (inkl. dependency injection)
     */
    constructor() {}

    /**
     * Initialisieren
     */
    ngOnInit() {}

    /**
     * Aufräumen
     */
    ngOnDestroy() {}
}
